'use client';
import React from 'react'
import ReferVoucher from './refer-voucher';
import { Input } from '@/stories/input/input';
import CopyToDashboard from '@/app/assets/icons/copy-to-dashboard';
import { ButtonSize, ButtonVariant, RegularButton } from '@/stories/button/button';
import { setAnalyticsEvent } from '@/app/utils/SetAnalyticsEvent';
import { useRouter } from 'next/navigation';
import { buildKycRedirectUrl } from '@/app/utils/kyc-routing';

const StartKycComp = ({ 
        isLoading, 
        voucherAmt, 
        voucherText, 
        hideTransactionBenefit, 
        kycFlow 
    } : { 
        isLoading: boolean; 
        voucherAmt?: number; 
        voucherText?: string; 
        hideTransactionBenefit?: 
        boolean; kycFlow?: string 
    }) => {
    const router = useRouter();

    if(isLoading) {
        return (
            <div className="flex flex-col items-center justify-center md:flex-row md:justify-between w-full md:w-[1152px] md:gap-[84px] md:px-[68px] my-5 md:my-14 animate-pulse">
                <div className="w-full h-full flex justify-end">
                    <div className="bg-neutral-100 rounded-lg w-60 h-40" />
                </div>
                <div className="hidden md:block min-h-[423px] bg-white min-w-[525px] rounded-[16px] shadow-lg relative">
                    <div className="min-h-[423px] min-w-[525px] rounded-[16px] bg-white shadow-lg pointer-events-none">
                        <div className="rounded-t-[16px] border border-b-neutralOpacityDark-10 px-s13 py-s9 text-center">
                            <div className="h-8 bg-neutral-100 rounded w-1/2 mx-auto" />
                        </div>
                        <div className="flex flex-col gap-6 p-8">
                            <div className="w-full">
                                <div className="mb-2 h-4 bg-neutral-100 rounded w-1/3" />
                                <div className="min-h-14 rounded-[12px] bg-neutral-100 w-full" />
                            </div>
                            <div className="w-full">
                                <div className="mb-2 h-4 bg-neutral-100 rounded w-1/3" />
                                <div className="min-h-14 rounded-[12px] bg-neutral-100 w-full" />
                            </div>
                            <div className="flex w-full flex-col items-center justify-center">
                                <div className="h-12 bg-neutral-100 rounded w-full" />
                            </div>
                        </div>
                    </div>
                    <div className="min-h-full bg-white min-w-[525px] rounded-[16px] absolute top-0 z-1 opacity-90 p-14 flex flex-col items-center justify-end">
                        <div className="h-12 bg-neutral-100 rounded w-4/5 mb-8" />
                        <div className="h-12 bg-neutral-100 rounded w-1/2" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center md:flex-row md:justify-between w-full md:w-[1152px] md:gap-[84px] md:px-[68px] my-5 md:my-14">
            {/* <p className="block md:hidden text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] mt-6 mb-2 text-center">Earn up to ₹10,000 for <br/>every referral</p>
            <p className="block md:hidden text-lg font-semibold leading-[23.4px] mb-5 text-neutral-500 text-center">Invite your friends to {ICM_NAME_FULL} <br/>today!</p> */}
            <div className="w-full h-full flex justify-end">
                <ReferVoucher voucherAmt={voucherAmt} voucherText={voucherText} hideTransactionBenefit={hideTransactionBenefit} />
            </div>
            <div className="hidden md:block min-h-[423px] bg-white min-w-[525px] rounded-[16px] shadow-lg relative">
                <div className="min-h-[423px] min-w-[525px] rounded-[16px] bg-white shadow-lg pointer-events-none">
                    <div className="rounded-t-[16px] border border-b-neutralOpacityDark-10 px-s13 py-s9 text-center text-3xl font-semibold leading-[31.2px] tracking-[-0.24px]">
                        Refer Now
                    </div>
                    <div className="flex flex-col gap-6 p-8">
                        <div className="w-full">
                            <p className="mb-2 text-sm leading-[19.6px] text-neutral-300">Enter mail id*</p>
                            <Input
                                placeholder="abc@gmail.com"
                                showIcon={false}
                                className="min-h-14 rounded-[12px] border border-neutralOpacityDark-10 py-s7 text-md leading-[22.4px] text-neutral-900"
                                // disabled={true}
                                readOnly
                            />
                        </div>
                        <div className="w-full">
                            <p className="mb-2 text-sm leading-[19.6px] text-neutral-300">Share referral link</p>
                            <Input
                                placeholder="Referral Code"
                                showIcon={false}
                                showRightIcon={true}
                                icon={<CopyToDashboard className="cursor-pointer" />}
                                className="min-h-14 rounded-[12px] border border-neutralOpacityDark-10 py-s7 text-md leading-[22.4px] text-neutral-900"
                                readOnly
                            />
                        </div>
                        <div className="flex w-full flex-col items-center justify-center">
                            <RegularButton
                                noIcon
                                showRightIcon={false}
                                size={ButtonSize.Large}
                                variant={ButtonVariant.PrimaryDefault}
                                label="Share Invite"
                                disabled={true}
                                className="w-full max-w-full"
                            />
                        </div>
                    </div>
                </div>
                <div className="min-h-full bg-white min-w-[525px] rounded-[16px] absolute top-0 z-1 opacity-90 p-14 flex flex-col items-center justify-end">
                    <p className="text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] text-center mb-[47px]">
                        Complete your KYC to be eligible to Refer
                    </p>
                    <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.PrimaryDefault}
                        className="max-w-1/2 w-full sm:w-3/5 md:max-w-fit"
                        label="Start KYC"
                        onClick={() => {
                            setAnalyticsEvent(`${process.env.ICM_URL}/refer`, "US_Listing_Page_Refer_Friend_Fold 8");
                            router.push(buildKycRedirectUrl({ 
                                kycFlow, redirectUrl: '/refer' 
                            }))
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default StartKycComp